module.exports = __webpack_public_path__ + "img/fly zipper length.c1c48310.png";